module.exports = require('./dist/src/runtime');


//////////////////
// WEBPACK FOOTER
// ../node_modules/stylable/runtime.js
// module id = 2
// module chunks = 0